import client from '@/api/base';

export default {
  async getLGA() {
    const response = await client.get('events/engagement/lga/');
    return response;
  },

  async updateLGA(data) {
    const response = await client.patch('events/engagement/lga/', data);
    return response;
  },

  async updateLeaderLGA(id, data) {
    const response = await client.patch(`coaching/engagement/leader/${id}/lga/`, data);
    return response;
  },
};
